import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ReactComponent as AddDeviceIcon } from "../../../src/assets/images/checkInAndOutDevice/AddDeviceIcon.svg";
import { REACT_URL_VISITORACCESSLEVEL } from "../../actions/EndPoints";
import { ReactComponent as AddDeviceIconUSA } from "../../assets/USA_Images/adddeviceusa.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import { addAccessLevel } from "../../slices/PurposeTypeUSA/PurposeTypeAccesslevelUSASlice";
import { getVisitorAccessLevels } from "../../slices/VisitorAccessLevels/VisitorAccessLevelSlice";

export default function VisitorAddAccessLevelDialog(props) {
  const { handleClose } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [rows, setRows] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [selectedAccessLevels, onSelectionChange] = useState([]);
  const [seletedNames, setSelectedNames] = useState("");
  const history = useHistory();
  let accessLevelID = [];

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 10,
  });

  useEffect(() => {
    loadCloudAccess_Levels(paging);
  }, [paging]);

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };
  const onSelectionRowdata = (ids) => {
    const selectedRowDataNames = rows
      .filter((row) => ids.includes(row.id.toString()))
      .map((row) => row.name);
    setSelectedNames(selectedRowDataNames.join(", "));
    const selectedRowData = ids;
    onSelectionChange(selectedRowData);
  };

  //

  const loadCloudAccess_Levels = (paging) => {
    const query = {
      page: paging.page,
      rowsPerPage: paging.rowsPerPage,
    };
    dispatch(getVisitorAccessLevels(query))
      .unwrap()
      .then((data) => {
        if ((data.code = "DMSI0000" && data.data)) {
          setPage(data.data.currentPage);
          setRows(data.data.accessGroups);
          setTotalPages(data.data.totalPages);
          setTotalRecords(data.data.totalCount);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  const columns = [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return <div></div>;
      },
    },

    {
      field: "name",
      headerName: t("COMMON044"),
      flex: 1,
    },
    {
      field: "timeSlotName",
      headerName: t("VISACCLEVDIAL001"),
      flex: 1,
    },

    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 1,
      width: 150,
      headerAlign: "center",

      getActions: (params) => [
        <GridActionsCellItem
          icon={
            process.env.REACT_APP_ENVIRONMENT === "USA" ? (
              <AddDeviceIconUSA />
            ) : (
              <AddDeviceIcon />
            )
          }
          label="Add"
          onClick={() => handleAddIconClick([params.row])}
        />,
      ],
    },
  ];

  const handleSubmitAdd = (data) => {
    let object = {};
    if (data.length < 1) {
      Toast(t("COMMON019"), "warning");
      return;
    }
    if (data.length === 1) {
      let array = [data[0]];
      object = {
        id: history.location.state.state.id,
        purposeTypeName: history.location.state.state.name,
        names: seletedNames,
        ids: array,
      };
    } else {
      object = {
        id: history.location.state.state.id,
        purposeTypeName: history.location.state.state.name,
        names: seletedNames,
        ids: selectedAccessLevels,
      };
    }
    accessLevelID.push(object.ids.ids);
    dispatch(addAccessLevel(object))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0046") {
          Toast(t("ADD_ACCESS_LEVEL"), "success");
          history.push({
            pathname: REACT_URL_VISITORACCESSLEVEL,
            state: { data: data.data },
          });
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((er) => { });
  };

  const handleAddIconClick = (data) => {
    let object = {};
    if (data.length < 1) {
      Toast(t("COMMON019"), "warning");
      return;
    }
    if (data.length === 1) {
      let array = [data[0].id];
      object = {
        id: history.location.state.state.id,
        ids: array,
        names: data[0].name,
        purposeTypeName: history.location.state.state.name,
      };
    } else {
      object = {
        id: history.location.state.state.id,
        ids: selectedAccessLevels,
        names: seletedNames,
        purposeTypeName: history.location.state.state.name,
      };
    }
    accessLevelID.push(object.ids.ids);
    dispatch(addAccessLevel(object))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0046") {
          Toast(t("ADD_ACCESS_LEVEL"), "success");
          history.push({
            pathname: REACT_URL_VISITORACCESSLEVEL,
            state: { data: data.data },
          });
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((er) => { });
  };

  return (
    <>
      <HeaderToolbar title={t("VISACCLEVEL001")} back_button={true} />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        gap="5px"
      >
        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadCloudAccess_Levels(paging)} />
          </Box>
        </Tooltip>
      </Box>
      <div>
        <DataTableLatest
          checkboxSelection
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          addAccessLevel={true}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
          onSelectionModelChange={(ids) => onSelectionRowdata(ids)}
        />
      </div>
      <Grid
        style={{ display: "flex", justifyContent: "end", margin: "15px 2px" }}
      >
        <CancelButtons
          variant="contained"
          color="secondary"
          onClick={() => history.goBack()}
          onClose={handleClose}
          cancel={handleClose}
          style={{ marginRight: "10px" }}
        >
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {t("COMMON008")}
          </Typography>
        </CancelButtons>
        <SubmitButtons
          variant="contained"
          onClick={() => handleSubmitAdd(selectedAccessLevels)}
        >
          <Typography variant="body1" style={{ textTransform: "none" }}>
            {t("COMMON007")}
          </Typography>
        </SubmitButtons>
      </Grid>
    </>
  );
}
